const LoadingSpinner = ({ size = 'default', text = 'Yüklənir...' }) => {
  const sizeClasses = {
    small: 'w-6 h-6',
    default: 'w-12 h-12',
    large: 'w-16 h-16',
  };

  return (
    <div className="flex flex-col items-center justify-center py-20" data-testid="loading-spinner">
      <div className={`${sizeClasses[size]} relative`}>
        <div className="absolute inset-0 border-4 border-brand-secondary rounded-full"></div>
        <div className="absolute inset-0 border-4 border-transparent border-t-brand-primary rounded-full animate-spin"></div>
      </div>
      {text && (
        <p className="mt-4 text-sm text-brand-muted font-medium">{text}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
